import useEntityDuplicateData from './use-entity-duplicate-data';
import useEntityId from './use-entity-id';

const useCurrentEntityDuplicateData = (timestamp?: string, enabled?: boolean) => {
  const id = useEntityId();
  return useEntityDuplicateData(id, timestamp, enabled);
};

export default useCurrentEntityDuplicateData;
